export enum ContentType {
  changeCipherSpec = 20,
  alert = 21,
  handshake = 22,
  applicationData = 23,
}
